import _ from 'lodash';

/**
 * Given an array of weights and items, pick one value with appropriate probability
 * @param {Object[]} items
 * @returns {*}
 * @example
 * weightedPick([
 *   { weight:9, value:'Red' },
 *   { weight:1, value:'White' },
 * ])
 * // 90% of the time Red, 10% White
 * // note that the total of weight can be any number
 */
export function weightedPick(items) {
	let totalWeight = _.sum(_.pluck(items, 'weight'));
	let rand = _.random(1, totalWeight);
	let total = 0;
	let i;
	for (i = 0; i < items.length; i++) {
		total += items[i].weight;
		if (rand <= total) {
			return items[i].value;
		}
	}
}
